var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcCollapse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "7px",
    height: "13px",
    viewBox: "0 0 7 13",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "btn-more") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "01-MyClients-planningList-actions-activitiesListAssign",
    transform: "translate(-1020.000000, -300.000000)",
    fill: "#646464",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-28",
    transform: "translate(423.000000, 134.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-24",
    transform: "translate(515.000000, 163.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(80.000000, 6.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "btn-more",
    transform: "translate(6.000000, 3.333333) rotate(-90.000000) translate(-6.000000, -3.333333) "
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.80335017,8.1366835 C2.6211055,8.31892817 2.6211055,8.61440516 2.80335017,8.79664983 C2.98559484,8.9788945 3.28107183,8.9788945 3.4633165,8.79664983 L8.79664983,3.4633165 C8.9788945,3.28107183 8.9788945,2.98559484 8.79664983,2.80335017 L3.4633165,-2.52998316 C3.28107183,-2.71222783 2.98559484,-2.71222783 2.80335017,-2.52998316 C2.6211055,-2.3477385 2.6211055,-2.0522615 2.80335017,-1.87001684 L7.80670034,3.13333333 L2.80335017,8.1366835 Z",
    id: "Stroke-718",
    transform: "translate(5.800000, 3.133333) rotate(-270.000000) translate(-5.800000, -3.133333) "
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCollapse);
export default __webpack_public_path__ + "static/media/ic-collapse.7b0eb3dcf16f4dfa55a97d979ce07df9.svg";
export { ForwardRef as ReactComponent };